import { makeStyles, shorthands, tokens } from "@fluentui/react-components";

export const useStyle = makeStyles({
	root: {
		...shorthands.outline(
			tokens.strokeWidthThin,
			"solid",
			tokens.colorNeutralStroke1
		),
		...shorthands.borderRadius(tokens.borderRadiusMedium),
		...shorthands.overflow("hidden"),
		paddingLeft: "8px",
		maxWidth: "550px",
		backgroundColor: tokens.colorNeutralBackground1,
		display: "flex",
		justifyContent: "space-between",
	},
	error: {
		...shorthands.outline(
			tokens.strokeWidthThin,
			"solid",
			tokens.colorPaletteRedBorder1
		),
		backgroundColor: tokens.colorPaletteRedBackground1,
	},
});
